export default __webpack_public_path__ + "static/ias-7b577e97323c35b1fea2da93eff650fd.jpg";